import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

interface PageEvent {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}

@Component({
  selector: 'app-customer-info',
  templateUrl: './customer-info.component.html',
  styleUrls: ['./customer-info.component.css']
})
export class CustomerInfoComponent implements OnInit {

  cid: any;
  form: any | FormGroup
  paramData: any = []
  customerInfo: any = []
  imgUrl1 = ''
  imgUrl2 = ''
  file1: File | undefined;
  file2: File | undefined;
  singleCustomerInfo: any= []


  latitude: any;
  longitude: any;
  url1: any = '';
  documents: any = []
  file!: File;
  SingleDocument: any = "";
  PdfSrc: any;
  doc: any = []
  buttonDisable = false

  pageNumber1: number = 0;
  pageNumber: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  serviceData: any = []

  constructor(private route: ActivatedRoute,private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService,private router: Router) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action


    this.cid = sessionStorage.getItem('cid')
    // this.getLocation()
    this.getAllServices()
    this.getCustomerInfo(this.pageNumber,this.recordsPerPage)
    this.getCustomerParams()
    this.form = this.fb.group({
      name: [''],
      description: [''],
      address: [''],
      mobileNo1: [''],
      mobileNo2: [''],
      emailId: [''],
      serviceName: [''],
      image: [''],
      customerParamEntityList:this.fb.array([]),
    })
    this.addInfoObject()


  }

  onTableDataChange(event: any) {
    this.pageNumber = event.target.value;

    this.getCustomerInfo(this.pageNumber-1,this.recordsPerPage);
  }
  onTableSizeChange(event: any): void {
    this.pageNumber = event.target.value;
    this.getCustomerInfo(this.pageNumber-1,this.recordsPerPage);
  }

   get paramArr(){
    return this.form.get('customerParamEntityList') as FormArray;
  }

  paramObject(){
    return this.fb.group({
      "key": [''],
      "value": [''],
    })
   }
  
   addInfoObject(){
    // this.infoArr.clear()
    this.paramArr.push(this.paramObject())
   }

   removeParamObject(index: number){
    this.paramArr.removeAt(index)
   }

  addCustomer(){
    this.buttonDisable = true

    let customerParamEntityList:any = []

    for(let i = 0; i < this.paramData.length; i++){
      customerParamEntityList.push(
        {
          "key": this.paramData[i].name,
          "value": this.paramData[i].value
        }
      )
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.form.get('description').value),
      "name": String(this.form.get('name').value),
      "address": String(this.form.get('address').value),
      "serviceName": String(this.form.get('serviceName').value),
      "mobileNo1": String(this.form.get('mobileNo1').value),
      "mobileNo2": String(this.form.get('mobileNo2').value),
      "emailId": String(this.form.get('emailId').value),
      "customerParamEntityList": customerParamEntityList,
      "image": this.url1,
      "documents": this.documents,
      "cid": this.cid,



  "lmoDataId": 0,
  "geoAddress": [
    {
      "slNo": "",
      "name": "",
      "phone1": "",
      "phone2": "",
      "email": "",
      "latitude": String(this.latitude),
      "longitude": String(this.longitude),
      "address": "",
      "postCode": "",
      "isDefault": true,
      "type": "",
      "state": "",
      "landmark": "",
      "city": "",
      "town": "",
      "district": ""
    }
  ],
  "customerType": "",
  "belongsTo": "",
  "password": "",

  "interestedProducts": [
    {
      "id": "",
      "name": "",
      "uom": "",
      "price": "",
      "keyValuePair": [
        {
          "key": "",
          "value": ""
        }
      ]
    }
  ],
  "status": [
    {
      "customerRegistrationStatus": "REQUESTED",
      "updatedDate": 0
    }
  ],
    "latestStatus": "REQUESTED"
    }

    console.log(body)
    this.generic_service.addCustomerInfo(body).subscribe(
      (response:any) => {
        console.log(response)
        this.getCustomerInfo(this.pageNumber-1,this.recordsPerPage)
        this.toastr.success(response.message)
        this.cancelModel()
        this.Reset()
      },
      (error:any)=>{
        console.log(error)
        this.buttonDisable = false
      }
    )
  }

  Reset(){
    this.form.reset()
    this.buttonDisable = false
  }


  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton4")?.click()
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: any) => {
        if (position) {
          console.log("Latitude: " + position.coords.latitude +
            "Longitude: " + position.coords.longitude);
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          console.log(this.latitude);
          console.log(this.longitude);
        }
      },
        (error: any) => console.log(error));
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  getCustomerParams(){
    // this.generic_service.getCustomerParams().subscribe(
    //   (res:any)=> {
    //     console.log(res)
    //     this.paramData = res.response
    //   },
    //   (err:any)=>{
    //     console.log(err)
    //   }
    // )

    this.generic_service.predefinedParameter('CUSTREG').subscribe(
      (response:any)=>{
          console.log(response)
          for(let i=0; i<response.response.length; i++){
            this.paramData.push(
              {
                name: response.response[i].name,
                possibleValue: response.response[i].possibleValue,
                value: ""
              }
            )
          }
          console.log(this.paramData)
      },
      (err:any)=>{
          console.log(err)
      }
    )
  }

  getCustomerInfo(pageNumber: any,recordsPerPage: any){
    this.generic_service.getCustomerInfo(pageNumber,recordsPerPage).subscribe(
      (res:any)=> {
        console.log(res)
        this.customerInfo = res.response.customerInfoList
        this.totalRecords = res.response.totalRecords

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  onSelectFile(event: any) {
    this.file1 = event.target.files[0]
      if (event.target.files) {
        var reader = new FileReader;
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (e: any) => {
          this.url1 = e.target.result
        }
      }
  }

  addDoc(){

  }

  getCustomerInfoById(id:any){
    this.generic_service.getCustomerInfoById(id).subscribe(
      (res:any)=>{
        console.log(res)
        this.singleCustomerInfo = []
        this.singleCustomerInfo.push(res.response)
        this.documents = []
        this.documents = res.response.documents
        this.doc = []
        this.doc = res.response.documents
        if(this.doc != null && this.doc != undefined){
          for(let i=0; i<this.doc.length; i++){
            if(this.doc[i].includes('.jpg') || this.doc[i].includes('.png')){
              let obj = {
                type: 'image',
                url: this.doc[i]
              }
              this.doc.push(obj);
  
            }else{
              let obj = {
                type: 'doc',
                url: this.doc[i]
              }
              this.doc.push(obj);
            }
          }
        }
   

        console.log(this.doc)
        
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  viewImage(document:string){
    this.SingleDocument = document
    // this.PdfSrc = document
  }

  approveCustomerInfo(){
    let body = {
        "id": this.singleCustomerInfo[0].id,
        "customerRegistrationStatusDTO": {
          "customerRegistrationStatus": "APPROVED",
          "updatedDate": new Date().getTime()
        }
    }

    console.log(body)
    this.generic_service.approveCustomerInfo(body).subscribe(
      (res:any)=>{
        console.log(res)
        this.toastr.success("Successfully approved")
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
      }
    )
  }

  rejectCustomerInfo(){
    let body = {
        "id": this.singleCustomerInfo[0].id,
        "customerRegistrationStatusDTO": {
          "customerRegistrationStatus": "REJECTED",
          "updatedDate": new Date().getTime()
        }
    }

    console.log(body)
    this.generic_service.rejectCustomerInfo(body).subscribe(
      (res:any)=>{
        console.log(res)
        this.toastr.success("Successfully rejected")
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
      }
    )
  }

  onChange(event: any) {
    this.file = event.target.files[0];
    this.onUpload()
  }
  
  onUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.documents.push(event.response)
  
    });
  }

  addDocBtn(){
    document.getElementById("add-doc-btn")?.click()
  }

  goToLink(mobile:any,userID:any){
    let url = 'admin/customer-plans/'+mobile+'/'+userID;
    this.generic_service.menusType.next('customer')
    sessionStorage.setItem('menusType','customer')
    this.router.navigate([url]);
  }

  getAllServices(){
    this.generic_service.getAllServices().subscribe(
      (response:any)=>{
        this.serviceData = response.response;
        console.log(response)
      }
    )
  }


  first3: number = 0;

  rows3: number = 10;

  totalRecords: number = 0;

  onPageChange3(event: PageEvent) {
    this.pageNumber = event.page;
    this.getCustomerInfo(this.pageNumber,this.recordsPerPage)

  }
 
}